import React from "react";

export default function FilterBar({
  filters,
  masters,
  setFilter,
  onApply,
  onDownload,
  loading,
  downloading,
  data,
  isConsolidated,
}) {
  const update = (k, v) => setFilter((prev) => ({ ...prev, [k]: v }));

  return (
    <div className="card p-3 mb-4 shadow-sm">
      <div className="row g-3">
        <div className="col-md-3">
          <label className="form-label">Report Type</label>
          <select
            className="form-select"
            value={filters.type}
            onChange={(e) => update("type", e.target.value)}
          >
            <option value="daily">Daily</option>
            <option value="range">Range / Weekly</option>
            <option value="monthly">Monthly</option>
          </select>
        </div>

        {filters.type === "daily" && (
          <div className="col-md-3">
            <label className="form-label">Date</label>
            <input
              type="date"
              className="form-control"
              value={filters.date}
              onChange={(e) => update("date", e.target.value)}
            />
          </div>
        )}

        {filters.type === "range" && (
          <>
            <div className="col-md-3">
              <label className="form-label">From</label>
              <input
                type="date"
                className="form-control"
                value={filters.from_date}
                onChange={(e) => update("from_date", e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <label className="form-label">To</label>
              <input
                type="date"
                className="form-control"
                value={filters.to_date}
                onChange={(e) => update("to_date", e.target.value)}
              />
            </div>
          </>
        )}

        {filters.type === "monthly" && (
          <div className="col-md-3">
            <label className="form-label">Month</label>
            <input
              type="month"
              className="form-control"
              value={filters.month}
              onChange={(e) => update("month", e.target.value)}
            />
          </div>
        )}

        <div className="col-md-3">
          <label className="form-label">Outlet</label>
          <select
            className="form-select"
            value={filters.outlet}
            onChange={(e) => update("outlet", e.target.value)}
          >
            <option value="">All</option>
            {masters.outlets.map((o, i) => (
              <option key={i} value={o}>
                {o}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-3">
          <label className="form-label">Department</label>
          <select
            className="form-select"
            value={filters.department}
            onChange={(e) => update("department", e.target.value)}
          >
            <option value="">All</option>
            {masters.departments.map((d, i) => (
              <option key={i} value={d}>
                {d}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-3">
          <label className="form-label">Employee</label>
          <select
            className="form-select"
            value={filters.employee_id}
            onChange={(e) => update("employee_id", e.target.value)}
          >
            <option value="">All</option>
            {masters.employees.map((emp) => (
              <option key={emp.id} value={emp.id}>
                {emp.employee_code} - {emp.first_name}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-3 d-flex align-items-end">
          <button
            className="btn duty-roster-upload-btn gap-1 w-100"
            onClick={onApply}
          >
            {loading ? (
              <span className="spinner-border spinner-border-sm"></span>
            ) : (
              "Generate"
            )}
          </button>
        </div>

        <div className="col-md-3 d-flex align-items-end">
          <button
            className="btn btn-success w-100"
            onClick={onDownload}
            disabled={downloading || data.length === 0}
          >
            {downloading ? (
              <span className="spinner-border spinner-border-sm"></span>
            ) : (
              "⬇ Download"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
